interface LocalDevConfig {
  apiUrl: string | undefined;
  devHeaders: Record<string, string> | undefined;
}

const localDevConfig: LocalDevConfig | undefined =
  import.meta.env.MODE === "development"
    ? {
        apiUrl: "http://localhost:7071",
        devHeaders: {
          "x-claim-agent": "mitchell@urbanx.io",
          "x-claim-agency": "4b7a9fd9-5eb4-440a-8680-292e664be0c7",
          "x-claim-roles": "director,executive,businessmanager",
        },
      }
    : undefined;

export const getBaseUrl = (): string => {
  return localDevConfig?.apiUrl ?? import.meta.env.VITE_AGENTX_BASE_API;
};

export const getLocalDevHeaders = (): Record<string, string> => {
  return localDevConfig?.devHeaders ?? {};
};
